import _ from '../../core/utils'
const productConfig = {
    page: _.select( '.page--product' ),
    productBg: _.select( '.page--product .product__header .background' )
}

export default productConfig